<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR REGRA DE INFREQUÊNCIA' : 'NOVA REGRA DE INFREQUÊNCIA'" titleIcon="fas fa-user-clock">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome da regra" prop="nome" :rules="$requiredBlur">
                            <el-input v-model="dados.nome" placeholder="Ex.: 2 faltas consecutivas ou 3 alternadas em 5 dias úteis"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" prop="periodo_letivo_id" :rules="$requiredChange">
                            <el-select v-model="dados.periodo_letivo_id" style="width: 100%;">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Escopo" prop="escopo" :rules="$requiredChange">
                            <el-select v-model="dados.escopo" style="width: 100%;" @change="escopoMudou">
                                <el-option value="rede" label="Rede"></el-option>
                                <el-option value="instituicao" label="Escola"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item v-if="dados.escopo === 'instituicao'" label="Escola" prop="escopo_id" :rules="$requiredChange">
                    <el-select v-model="dados.escopo_id" filterable style="width: 100%;">
                        <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                    </el-select>
                </el-form-item>

                <h4 class="u-mt-10 u-mb-10">Gatilho</h4>
                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="Informe ao menos um gatilho. Vários gatilhos funcionam como OU: qualquer um deles dispara o alerta."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Janela (dias letivos)" prop="janela_dias_uteis" :rules="$requiredChange">
                            <el-input-number v-model="dados.janela_dias_uteis" :min="1" :max="60" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Faltas consecutivas">
                            <el-input-number v-model="dados.faltas_consecutivas" :min="1" :max="dados.janela_dias_uteis" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Faltas alternadas">
                            <el-input-number v-model="dados.faltas_alternadas" :min="1" :max="dados.janela_dias_uteis" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Frequência mínima (%)">
                            <el-input-number v-model="dados.percentual_minimo" :min="0" :max="100" :precision="2" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item>
                    <el-checkbox v-model="dados.considera_falta_justificada">
                        Contar também as faltas JUSTIFICADAS
                    </el-checkbox>
                    <div>
                        <small class="u-text-muted">
                            Desmarcado (padrão): a falta justificada não dispara alerta, porque a escola
                            já sabe o motivo da ausência — que é justamente o que a busca ativa apuraria.
                        </small>
                    </div>
                </el-form-item>

                <h4 class="u-mt-10 u-mb-10">Recorte e severidade</h4>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Modalidade (opcional)">
                            <el-select v-model="dados.modalidade_id" clearable filterable style="width: 100%;">
                                <el-option v-for="m in modalidades" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Nível escolar (opcional)">
                            <el-input-number v-model="dados.nivel_escolar" :min="0" :max="9" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Severidade" prop="severidade" :rules="$requiredChange">
                            <el-select v-model="dados.severidade" style="width: 100%;">
                                <el-option v-for="s in severidades" :key="s" :value="s" :label="s"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Ações quando a regra disparar" prop="acoes" :rules="$requiredChange">
                    <el-checkbox-group v-model="dados.acoes">
                        <el-checkbox v-for="a in acoes" :key="a.valor" :label="a.valor">{{ a.rotulo }}</el-checkbox>
                    </el-checkbox-group>
                    <div>
                        <small class="u-text-muted">
                            "Notificar o responsável" avisa os gestores da escola, que fazem o contato com
                            a família — não existe conta de responsável no sistema para receber push.
                        </small>
                    </div>
                </el-form-item>

                <el-form-item label="Situação">
                    <el-switch v-model="dados.situacao" active-text="Ativa" inactive-text="Inativa"></el-switch>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/regra-infrequencia"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO I — item 131. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        instituicoes: [], modalidades: [], severidades: [], acoes: [],
        dados: { nome: '', escopo: 'rede', escopo_id: null, periodo_letivo_id: null,
                 janela_dias_uteis: 5, faltas_consecutivas: 2, faltas_alternadas: 3,
                 percentual_minimo: null, modalidade_id: null, nivel_escolar: null,
                 severidade: 'media', acoes: ['alerta_painel'],
                 considera_falta_justificada: false, situacao: true }
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        if (!this.modoEdicao && this.$store.state.config.periodo) this.dados.periodo_letivo_id = this.$store.state.config.periodo.id

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/regra-infrequencia/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            this.severidades = (r.data && r.data.severidades) ? r.data.severidades : []
            this.acoes = (r.data && r.data.acoes) ? r.data.acoes : []
            this.modalidades = (r.data && r.data.modalidades) ? r.data.modalidades : []
        }).catch(e => this.$store.commit('throwException', e))

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/regra-infrequencia/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/regra-infrequencia')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
                if (!Array.isArray(this.dados.acoes)) this.dados.acoes = []
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        escopoMudou () { if (this.dados.escopo !== 'instituicao') this.dados.escopo_id = null },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/regra-infrequencia/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/regra-infrequencia/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Regra salva.', type: 'success' })
                    this.$router.push('/admin/regra-infrequencia')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
